import { Component, Input, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validators,
} from '@angular/forms';

@Component({
    selector: 'c-my-company-info',
    templateUrl: './my-company-info.component.html',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MyCompanyInfoComponent),
        multi: true,
      },
      {
        provide: NG_VALIDATORS,
        useExisting: forwardRef(() => MyCompanyInfoComponent),
        multi: true,
      },
    ],
    standalone: false
})
export class MyCompanyInfoComponent implements ControlValueAccessor {
  @Input() showInfo = true;
  @Input() adjustValidators = false;
  @Input() isReadOnly = false;
  @Input() loading = false;

  form = this.formBuilder.group({
    name: ['', Validators.required],
    companyNumber: [''],
    vatNumber: [''],
  });

  constructor(private formBuilder: FormBuilder) {}

  writeValue(obj: any): void {
    obj && this.form?.patchValue(obj, { emitEvent: false });

    if (!this.adjustValidators) {
      return;
    }

    if (obj.companyNumber) {
      this.form.get('companyNumber').setValidators([Validators.required]);
    } else {
      this.form.get('companyNumber').removeValidators([Validators.required]);
    }
    if (obj.vatNumber) {
      this.form.get('vatNumber').setValidators([Validators.required]);
    } else {
      this.form.get('vatNumber').removeValidators([Validators.required]);
    }
    this.form.updateValueAndValidity();
  }
  registerOnChange(fn: any): void {
    this.form?.valueChanges.subscribe(fn);
  }
  onTouched: () => void = () => {};
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.form.disable() : this.form.enable();
  }

  validate(): ValidationErrors | null {
    return this.form?.valid
      ? null
      : {
          invalidForm: {
            valid: false,
            message: `My Company Info fields are invalid`,
          },
        };
  }
}
